import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link, useLocation } from 'react-router-dom';
import logo from "../assets/images/finallogo.png"
import user from "../assets/images/user.png"
import { ShoppingCartIcon } from "@heroicons/react/24/outline";
import { useState } from 'react';

const navigation = [
      { name: 'Home', href: '/home', current: true },
      { name: 'About Us', href: '/about-us', current: false },
      { name: 'Services', href: '/hosting', current: false },
      { name: 'Contact Us', href: '/contact-us', current: false },
]

function classNames(...classes) {
      return classes.filter(Boolean).join(' ')
}

export default function Header() {
      const location = useLocation();
      const [showModal, setShowModal] = useState(false);
      const userData = localStorage.getItem("user") !== "undefined" && JSON.parse(localStorage.getItem("user"))
      const userToken = localStorage.getItem("token")

      const handleConfirmLogout = () => {
            localStorage.clear();
            window.location.href = "/login";
      };

      return (
            <Disclosure as="nav" className="relative z-30 border-b border-white/10 bg-[#171a1f]/95 backdrop-blur-xl">
                  <div className="absolute inset-0 bg-gradient-to-r from-[#223547]/95 via-[#1c2d3d]/95 to-[#17222e]/95"></div>
                  <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                        <div className="relative flex h-36 items-center justify-between">
                              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                    {/* Mobile menu button*/}
                                    <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset">
                                          <span className="absolute -inset-0.5" />
                                          <span className="sr-only">Open main menu</span>
                                          <Bars3Icon aria-hidden="true" className="block size-10 group-data-open:hidden" />
                                          <XMarkIcon aria-hidden="true" className="hidden size-10 group-data-open:block" />
                                    </DisclosureButton>
                              </div>
                              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                                          <Link to="/" className="flex shrink-0 items-center">
                                          <img
                                                alt="Orbitpay"
                                                src={logo}
                                                className="h-32 md:h-36 w-auto me-4"
                                          />
                                    </Link>
                                    <div className="hidden sm:block">
                                          <div className="absolute left-1/2 top-1/2 flex w-fit -translate-x-1/2 -translate-y-1/2 items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-2 py-1">
                                                {navigation.map((item, index) => (
                                                      <Link
                                                            key={item.name}
                                                            to={item.href}
                                                            className={classNames(
                                                                  location.pathname === item.href ? 'bg-gradient-to-r from-[#168de0] to-[#28b866] text-white shadow-md shadow-cyan-900/30' : 'text-gray-300 hover:bg-white/10 hover:text-white',
                                                                  'theme-nav-link rounded-full px-4 py-2 text-sm font-medium transition-all duration-200'
                                                            )}
                                                      >
                                                            {item.name}
                                                      </Link>
                                                ))}
                                          </div>
                                    </div>
                              </div>


                              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                                    {/* <button
                                          type="button"
                                          className="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 focus:outline-hidden"
                                    >
                                          <span className="absolute -inset-1.5" />
                                          <span className="sr-only">View notifications</span>
                                          <BellIcon aria-hidden="true" className="size-6" />
                                    </button> */}

                                    {/* Profile dropdown */}
                                    <Menu as="div" className="relative ml-3 rounded-full border border-white/15 bg-white/[0.04] px-2 py-1">
                                          <div className="flex gap-3">
                                                <MenuButton className="relative flex items-center rounded-full text-sm bg-transparent">
                                                      <span className="absolute -inset-1.5" />
                                                      <img alt="" src={user} className="size-6 rounded-full" />
                                                      {userData && (
                                                            <div className="flex ml-2 items-center gap-4">
                                                                  <Link className="text-white md:block hidden">
                                                                        {userData?.name}
                                                                  </Link>

                                                            </div>
                                                      )}
                                                </MenuButton>
                                                <MenuButton className="relative flex rounded-full text-sm focus:ring-2 focus:ring-white/60 focus:outline-hidden">
                                                      {userData && (
                                                            <div className="flex items-center gap-4">
                                                                  <Link to="/cart">
                                                                        <button className="relative p-2 rounded-full theme-btn-secondary !border-cyan-400/40">
                                                                              <ShoppingCartIcon className="h-4 w-4 text-white" />

                                                                        </button>
                                                                  </Link>
                                                            </div>
                                                      )}
                                                </MenuButton>
                                          </div>
                                          <MenuItems
                                                transition
                                                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                                          >
                                                <MenuItem>
                                                      {!userToken ? <Link to="/login" className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden">
                                                            Log in
                                                      </Link> :
                                                            <>

                                                                  <Link to="/my-account" className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden">
                                                                        Profile
                                                                  </Link>
                                                                  <Link
                                                                        onClick={(e) => {
                                                                              e.preventDefault();
                                                                              setShowModal(true);
                                                                        }}
                                                                        to="#"
                                                                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                                  >
                                                                        Log out
                                                                  </Link>

                                                            </>
                                                      }
                                                </MenuItem>
                                          </MenuItems>

                                    </Menu>

                              </div>


                        </div>
                  </div>

                  {showModal && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                              <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
                                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Confirm Logout</h2>
                                    <p className="text-gray-600 mb-6">Are you sure you want to log out?</p>
                                    <div className="flex justify-end space-x-4">
                                          <button
                                                onClick={() => setShowModal(false)}
                                                className="px-4 py-2 text-sm rounded bg-gray-200 hover:bg-gray-300 text-gray-800"
                                          >
                                                Cancel
                                          </button>
                                          <button
                                                onClick={handleConfirmLogout}
                                                className="px-4 py-2 text-sm rounded bg-red-500 hover:bg-red-600 text-white"
                                          >
                                                Confirm
                                          </button>
                                    </div>
                              </div>
                        </div>
                  )}

                  <DisclosurePanel className="sm:hidden">
                        <div className="space-y-1 px-2 pt-2 pb-3 relative">
                              {navigation.map((item) => (
                                    <DisclosureButton key={item.name} as="div" className="block">
                                          <Link
                                                to={item.href}
                                                className={classNames(
                                                      location.pathname === item.href ? "bg-gray-900 text-white" : "text-gray-300 hover:bg-gray-700 hover:text-white",
                                                      "block rounded-md px-3 py-2 text-base font-medium"
                                                )}
                                          >
                                                {item.name}
                                          </Link>
                                    </DisclosureButton>
                              ))}
                        </div>
                  </DisclosurePanel>
            </Disclosure>
      )
}
